import { render, staticRenderFns } from "./internal-memo.vue?vue&type=template&id=9bedc3d0&"
import script from "./internal-memo.vue?vue&type=script&lang=js&"
export * from "./internal-memo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports